import { useState } from 'react'

import { initRequestParam } from 'constants/constants'

import _ from 'lodash'
import { useCurrentStatusStore } from 'store/currentStatusStore'
import { getAPI } from 'utils/getAPI'

import type { GetMonthReportMonthReportGetRequest, MonthReports, ResponseResult } from 'api-client'
import type { ErrorResponse } from 'types/types'

export const useMonthReport = () => {
  const [monthReport, setMonthReport] = useState<MonthReports>(initRequestParam)
  const [isLoading, setIsLoading] = useState(false)
  const [result, setResult] = useState<ResponseResult | undefined>(undefined)
  const { setCurrentStatuses } = useCurrentStatusStore()

  const fetchMonthReport = async (searchParam: GetMonthReportMonthReportGetRequest) => {
    setMonthReport(initRequestParam)
    setResult(undefined)
    setIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.getMonthReportMonthReportGet({
        ...searchParam,
        centerId: searchParam.centerId || undefined,
        itemCode: searchParam.itemCode || undefined,
      })

      setMonthReport({
        ...response.data,
        list: _.map(response.data.list, (value) => {
          const recDate = new Date(value.recDate as Date)
          return {
            ...value,
            // // rechartsライブラリのdataKeyに合わせてstringにする
            recDateToNumber: recDate.getTime(),
          }
        }),
      })
      setResult(response.result)
      setCurrentStatuses(response.result.systemInfo?.sysCurrentStatus)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      setResult({
        status: 'error',
        message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `月報取得でエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      })
      return undefined
    } finally {
      setIsLoading(false)
    }
  }

  return {
    result,
    monthReport,
    fetchMonthReport,
    isLoading,
  }
}
